import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  center: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
  },
});

function NotFoundPage() {
  const classes = useStyles();

  return (
    <div className={classes.center}>
      LA PAGINA NO EXISTE
    </div>
  );
}

export default NotFoundPage;
